import { AlertMessage } from "./Alert";
import { useAlertsState, useAlertsActions } from "../../../store/GlobalContext";

export function useDispatchAlert(): (m: AlertMessage) => void {
  const { updateAlertsState } = useAlertsActions();
  const state = useAlertsState();

  return (message: AlertMessage) => {
    updateAlertsState({
      ...state,
      alertMessages: [...state.alertMessages, message],
    });
  };
}

export function useDispatchClearMessages() {
  const { updateAlertsState } = useAlertsActions();
  return () => {
    updateAlertsState({
      alertMessages: [],
    });
  };
}
